export const loobackApiUrl = "https://plwhs.com/api";
export const apiUrl = "https://api.plwhs.com";